
import React, { useState, useEffect } from 'react';
import useAuth from '../context/useAuth';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logo from '../images/newlogo.jpg';
import axios from '../api/axios';
import useApi from '../api/useApi';

const ForgotPassword = () => {
    const { setAuth } = useAuth();
    const api = useApi();
    const navigate = useNavigate();
    const location = useLocation();
    let from = location.state?.from?.pathname || '/home';

    const [username, setUsername] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [otp, setOTP] = useState('');
    const [otpToken, setOTPToken] = useState('');
    const [isOTPsent, setIsOTPsent] = useState(false);
    const [disableInputs, setDisableInputs] = useState(false);
    const [isPasswordReset, setIsPasswordReset] = useState(false);
    const [seconds, setSeconds] = useState(120);

    const handleSendOTP = async () => {

        if (username && mobileNumber) {
            const params = {
                userCode: username,
                mobileNumber: mobileNumber,
            };
            await api.sendPasswordResetOTP(params).then((response) => {
                if (response.success) {
                    setIsOTPsent(true);
                    setOTPToken(response.payload);
                    startCountdown(); 
                    //alert(response.message);
                }
                else
                    alert(response.message);

            }).catch((error) => {
                alert('Unable to process your request at this time.', error)
            });
        }
        else
            alert("Please enter user code and mobile number");
    };

    const handleValidateOTP = async () => {

        if (username && mobileNumber & otp && newPassword) {

            if (newPassword === confirmPassword) {
                const params = {
                    userCode: username,
                    mobileNumber: mobileNumber,
                    token: otpToken,
                    otp: otp,
                    newPassword: newPassword
                };
                setDisableInputs(true);
                await api.validateOTP(params).then((response) => {
                    if (response.success) {
                        setIsPasswordReset(true);
                    }
                    else {
                        setDisableInputs(false);
                        alert(response.message);

                    }

                }).catch((error) => {
                    setDisableInputs(false);
                    alert('Unable to process your request at this time.', error)
                });
            }
            else
                alert("New password & confirm password does not match.");
        }
        else
            alert("Please enter valid OTP & new password.");
    };

    const handleGoToLogin = async () => {
        navigate('/');
    }

    const startCountdown = () => {
        setSeconds(120);
        const intervalId = setInterval(() => {
            setSeconds(prevSeconds => {
                if (prevSeconds === 0) {
                    clearInterval(intervalId);
                    return 0;
                } else {
                    return prevSeconds - 1;
                }
            });
        }, 1000);
    };

    return (
        <div className="ltr main-body leftmenu error-1">
            <div className="page main-signin-wrapper">
                <div className="d-flex header-setting-icon demo-icon fa-spin">
                </div>
                <div className="row signpages text-center">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="row row-sm">
                                <div className="col-lg-6 col-xl-5 d-none d-lg-block text-center  details">
                                    <div className="mt-5 mb-5 pt-4 p-2 ">

                                        <img src={logo} className="header-brand-img mb-4" style={{ maxWidth: "80%" }} alt="logo" />
                                        <div className="clearfix"></div>
                                        <h3 className="mt-4 text-primary" >eAuction System</h3>
                                        <div className="tx-13 mt-5 mt-xl-5">Contact Us</div>
                                        <div className="tx-13 mt-xl-0">Phone: 0484-2333610</div>
                                        <div className="tx-13 mt-xl-0">Email: marketing.sb-ker@gov.in</div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-xl-7 col-xs-12 col-sm-12 login_form ">
                                    <div className="main-container container-fluid">
                                        <div className="row row-sm">
                                            <div className="card-body mt-2 mb-2">
                                                <img src={logo} className="d-lg-none header-brand-img text-start  mb-4 error-logo-light wd-70p mg-t-0 mg-r-auto mg-b-0 mg-l-auto" alt="logo" />
                                                <img src={logo} className=" d-lg-none header-brand-img text-start mb-4 error-logo wd-70p mg-t-0 mg-r-auto mg-b-0 mg-l-auto" alt="logo" />
                                                <div className="clearfix"></div>
                                                <form>
                                                    <h5 className="text-start mb-2">Forgot password</h5>
                                                    {/*<p className="mb-4 text-muted tx-13 ms-0 text-start">Signin to create, discover and connect with the global community</p>*/}
                                                    <div className={isOTPsent ? "form-group text-start d-none" : "form-group text-start"} >
                                                        <input className="form-control" disabled={isOTPsent} placeholder="User Code" type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
                                                    </div>
                                                    <div className={isOTPsent ? "form-group text-start d-none" : "form-group text-start"} >
                                                        <input className="form-control" disabled={isOTPsent} maxLength={10} placeholder="Registered Mobile Number" type="text" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} />
                                                    </div>

                                                    {isOTPsent  ?
                                                        <div className="form-group text-start">
                                                            <input className="form-control" disabled={disableInputs} placeholder="One time password (OTP)" type="text" value={otp} onChange={(e) => setOTP(e.target.value)} />
                                                        </div> : null}

                                                    {isOTPsent  ?
                                                        <div className="form-group text-start">
                                                            <input className="form-control" autocomplete="new-password" maxLength={20} disabled={disableInputs} placeholder="Password" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                                                        </div>
                                                        : null}
                                                    {isOTPsent  ?
                                                        <div className="form-group text-start">
                                                            <input className="form-control" autocomplete="new-password" maxLength={20} disabled={disableInputs} placeholder="Confirm Password" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                                                        </div>
                                                        : null}
                                                   
                                                    {isOTPsent && isPasswordReset === false ?
                                                        <div >
                                                            <p className="text-success">We have sent you One Time Password (OTP) on your registered mobile number via Whatsapp/SMS. Valid for 10 minutes. Please enter the OTP. </p>
                                                            {seconds > 0 ? <p>You can request new OTP after {seconds} seconds.</p> :
                                                                <p className="ms-4" > Still didn't get OTP.  <input type="button" value="RESEND" onClick={handleSendOTP} className="btn btn-sm btn-outline-primary"></input> </p>
                                                            }
                                                        </div>
                                                        : isPasswordReset ? <p className="text-success">Password reset successfully.</p> : null}

                                                    {isPasswordReset === false ?

                                                        isOTPsent ?
                                                            <input type="button" value="SUBMIT" className="btn ripple btn-main-primary btn-block" onClick={handleValidateOTP}></input>
                                                            :
                                                            <input type="button" value="GET OTP" className="btn ripple btn-main-primary btn-block" onClick={handleSendOTP}></input>
                                                        :
                                                        <input type="button" value="GO TO LOGIN PAGE" className="btn ripple btn-main-primary btn-block" onClick={handleGoToLogin}></input>
                                                    }

                                                </form>
                                                <div className="text-start mt-2 ms-0">
                                                    <div className="mb-1 mt-3">
                                                        If you already have password,  <a className="custom-link" href="/">Login</a> instead
                                                    </div>
                                                </div>
                                            </div> </div>
                                    </div>
                                </div> </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ForgotPassword;

;